import React from 'react';
import PropTypes from 'prop-types';

// class InstantQuote2 extends Parent {
//   prepareData() {
//     const parametersCustomer = this.props.parametersCustomer.toObject();
//     const parametersBestPrice = this.props.parametersBestPrice.toObject();
//     const options = {};
//
//     options[SupplierTypes.PLX_BEST_PRICE] = parametersBestPrice;
//     options[SupplierTypes.EXCEL_QUOTE] = parametersCustomer;
//     options[SupplierTypes.AMPEL_QUOTE] = parametersCustomer;
//
//     return options;
//   }
// }

const InstantQuote = ({ className, label, onQuoteRequest }) => (
  <div className="mb-3 d-grid">
    <button
      type="button"
      className={className}
      onClick={() => onQuoteRequest()}>
      {label}
    </button>
  </div>
)

InstantQuote.defaultProps = {
  className: 'btn btn-main-action',
  label: 'QUOTE',
};

InstantQuote.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  onQuoteRequest: PropTypes.func.isRequired,
}

export default InstantQuote;
